/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Social_PromotionInputs */

const en_landing_pricing_feature_social_promotion = /** @type {(inputs: Landing_Pricing_Feature_Social_PromotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social media promotion`)
};

const zh_landing_pricing_feature_social_promotion = /** @type {(inputs: Landing_Pricing_Feature_Social_PromotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社交媒体推广`)
};

/**
* | output |
* | --- |
* | "Social media promotion" |
*
* @param {Landing_Pricing_Feature_Social_PromotionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_social_promotion = /** @type {((inputs?: Landing_Pricing_Feature_Social_PromotionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Social_PromotionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_social_promotion(inputs)
	return zh_landing_pricing_feature_social_promotion(inputs)
});
export { landing_pricing_feature_social_promotion as "landing.pricing.feature_social_promotion" }